import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Field, FieldArray, reduxForm, formValueSelector } from 'redux-form'
import { DialogContainer } from 'react-md'

import { Checkbox, CheckboxInfo, TextField } from 'components'
import { breakLine } from 'lib/formatter'
import { required } from 'lib/validation'
import { TagSelect } from 'containers'
import { getTag } from 'redux/reducers'
import * as actions from 'redux/actions'

import TagList from './TagList'
import './index.css'

class BasicInfoView extends Component {
  constructor (props) {
    super(props)

    this.state = {
      helpMessage: ''
    }

    this.onHelpMessage = this.onHelpMessage.bind(this)
    this.clearHelpMessage = this.clearHelpMessage.bind(this)
    this.onTagSelect = this.onTagSelect.bind(this)
  }

  onHelpMessage (message) {
    this.setState({
      helpMessage: message
    })
  }

  clearHelpMessage () {
    this.setState({
      helpMessage: ''
    })
  }

  onTagSelect (value) {
    let { array, tags, getTag, toastAdd } = this.props

    if (tags.length >= 5) {
      toastAdd('You reached the tag limit.')
      return
    }

    const newTags = [ ...tags, value ]

    newTags.sort((a, b) => getTag(a).name.localeCompare(getTag(b).name))

    array.removeAll('tags')
    newTags.forEach(v => array.push('tags', v))
  }

  render () {
    const { readOnly, form } = this.props

    const { helpMessage } = this.state

    return (
      <div className='md-grid'>

        <DialogContainer
          id='help-message-dialog'
          visible={!!helpMessage}
          onHide={this.clearHelpMessage}
          title='Info'
          focusOnMount={false}
          portal
          width={500}
        >
          <p>{ breakLine(helpMessage) }</p>
        </DialogContainer>

        <Field
          id={`${form}-name`}
          className='md-cell md-cell--5'
          name='name'
          label='Name'
          component={TextField}
          validate={[ required ]}
          disabled={readOnly}
          required
        />

        <Field
          id={`${form}-description`}
          className='md-cell md-cell--9'
          name='description'
          label='Artwork Description'
          helpText='What inspired it? Is there a story behind it?'
          component={TextField}
          disabled={readOnly}
          rows={1}
          maxRows={4}
        />

        { !readOnly && (
          <FieldArray
            id={`${form}-tagSelect`}
            className='md-cell md-cel--12'
            name='tags'
            placeholder='Add a tag'
            helpText='Select from list or start typing. Max 5 tags allowed.'
            component={TagSelect}
            onChange={this.onTagSelect}
          />
        ) }

        <FieldArray
          id={`${form}-tags`}
          name='tags'
          component={TagList}
          disabled={readOnly}
        />

        <div className='option-list md-cell md-cell--12'>
          <Field
            id={`${form}-allowWholesale`}
            name='allowWholesale'
            label='Allow wholesale'
            component={CheckboxInfo}
            disabled={readOnly}
            info='Tick this box to make your art eligible to be sold across our
              partner network of retailers worldwide. We highly recommend it, as
              it’s a great way to boost sales.'
            onInfoClick={this.onHelpMessage}
            inline
          />
        </div>

        <div className='option-list md-cell md-cell--12'>
          <Field
            id={`${form}-matureContent`}
            name='matureContent'
            label='Mature content'
            component={Checkbox}
            disabled={readOnly}
            inline
          />
        </div>

      </div>
    )
  }
}
const mapStateToProps = (state, { form }) => {
  const selector = formValueSelector(form)
  return {
    tags: selector(state, 'tags'),
    getTag: (id) => getTag(state, id)
  }
}

const BasicInfoViewForm = reduxForm({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(BasicInfoView)

export default connect(mapStateToProps, actions)(BasicInfoViewForm)



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/BasicInfoView/index.js